import { IRootState } from '@/store';
import { GetterTree } from 'vuex';
import { IPraxisgruppeRechnungenState } from './state';

export const LIEFERANTENRECHNUNGEN = 'getLieferantenRechnungen';
export const LIEFERANTENRECHNUNGDETAILS = 'getLieferantenRechnungDetails';
export const LOADING = 'getLoading';
export const TOTAL_NUMBER_OF_RECORDS = 'getTotalNumberOfRecords';
export const GET_TVS_KUNDEN_VON_ZUGRIFFE = 'getTvsKundenVonZugriffe';

export const getters: GetterTree<IPraxisgruppeRechnungenState, IRootState> = {
    [LIEFERANTENRECHNUNGEN]: (state) => state.rechnungList,
    [LIEFERANTENRECHNUNGDETAILS]: (state) => state.rechnungenDetails,
    [LOADING]: (state) => state.loading,
    [TOTAL_NUMBER_OF_RECORDS]: (state) => state.totalNumberOfRecords,
    [GET_TVS_KUNDEN_VON_ZUGRIFFE]: (state) => state.tvsKundeTeilnehmerIdsForFilter
};
